import { render, staticRenderFns } from "./ModalVersionDownloads.vue?vue&type=template&id=924816d8&scoped=true&"
import script from "./ModalVersionDownloads.vue?vue&type=script&lang=js&"
export * from "./ModalVersionDownloads.vue?vue&type=script&lang=js&"
import style0 from "./ModalVersionDownloads.vue?vue&type=style&index=0&id=924816d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924816d8",
  null
  
)

export default component.exports